import Transfers from '../utils/Transfers';

/**
 * ログ出力パラメータ
 */
export interface ILogError {
	e: Error;
	info: React.ErrorInfo;
}

/**
 * 共通シナリオ作成クラス
 */
export default class CommonFactory {
	/**
	 * エラー送信シナリオ作成
	 */
	public static createLogError = (token: string) => {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class {
			protected readonly token: string;

			constructor() {
				this.token = token;
			}

			public run(arg: ILogError) {
				const { e, info } = arg;
				const log = {
					componentStack: info.componentStack,
					message: e.message,
					stack: e.stack,
				};
				this.logError(log);
			}

			protected logError = (e: any) => {
				// tslint:disable-next-line: no-console
				console.error(e);
				const timestamp = new Date();
				const log = {
					level: 'ERROR',
					message: JSON.stringify({
						message: e,
					}),
					timestamp: timestamp.getTime(),
				};
				const param = {
					logData: [JSON.stringify(log)],
				};
				Transfers.create(
					'tsq_common_ClientLogModel',
					this.token,
					param
				).catch(ex => {
					// tslint:disable-next-line: no-console
					console.error(ex);
				});
			};
		}();
		return scenario;
	};
}



// WEBPACK FOOTER //
// ./src/scenario/common.ts